module.exports = __webpack_public_path__ + "img/logo-footer-fr.1b96ee20.png";